import { cn } from '../../../lib/utils'
import React from 'react'

interface WorkoutStatTitleProps {
  children: React.ReactNode
  className?: string
}

export const WorkoutStatTitle = ({ children, className }: WorkoutStatTitleProps): React.ReactElement => {
  return (
    <p
      className={cn(
        'mt-[20px] font-roboto-condensed-medium text-center text-[21px] font-medium text-mushroom capitalize',
        className,
      )}
    >
      {children}
    </p>
  )
}
